import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import DIDProviders from "../../interfaces/didProviders";

interface DIDProvidersState {
    didProviders: DIDProviders[];
};

const initialState: DIDProvidersState = {
    didProviders: []
};

export const didProvidersSlice = createSlice({
    name: 'didProviders',
    initialState,
    reducers: {
        loadDIDProviders: (state, action: PayloadAction<DIDProviders[]>) => {
            state.didProviders = action.payload;
        }
    },
});

export const { loadDIDProviders } = didProvidersSlice.actions;

export default didProvidersSlice.reducer;